import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { unwrap } from '../lib/api-envelope';
import type { RentalBillingRules } from '../types/rental-haul';

/** One key for the billing rules, so the settings switch and every reader agree. */
export const BILLING_RULES_KEY = ['rentals', 'settings', 'billing-rules'] as const;

/**
 * Whether the company bills hauls by the hour (rentals-haul item 5, api#1054):
 * `bill_haul_hourly` on GET /surface-rentals/settings/billing-rules, which every
 * role may read. Haul hours and the haul rate are offered only when it is on.
 * Off while loading or when the read fails: the switch defaults off, and a
 * haul field shown to a company that does not bill hauls would ask for
 * nothing anyone uses.
 */
export function useBillHaulHourly(enabled = true) {
  const query = useQuery({
    queryKey: BILLING_RULES_KEY,
    queryFn: async () => unwrap<RentalBillingRules>((await api.rentals.settings.billingRules.get()).data),
    enabled,
    staleTime: 60_000,
  });
  return { on: query.data?.bill_haul_hourly === true, query };
}
